import { render, staticRenderFns } from "./HistoryLocationStatusLeyend.vue?vue&type=template&id=7070dd9a&scoped=true&"
import script from "./HistoryLocationStatusLeyend.vue?vue&type=script&lang=js&"
export * from "./HistoryLocationStatusLeyend.vue?vue&type=script&lang=js&"
import style0 from "./HistoryLocationStatusLeyend.vue?vue&type=style&index=0&id=7070dd9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070dd9a",
  null
  
)

export default component.exports